<form class="outer-form">
  <h3 class="dark-text-color">
    Assign {{ tasks.length }} task{{ tasks.length > 1 ? 's' : '' }} to:
  </h3>
  <mat-form-field class="full-width">
    <mat-label>Assign to</mat-label>
    <input
      type="text"
      placeholder="Type name"
      aria-label="Assign to"
      matInput
      [formControl]="selectUserControl"
      [matAutocomplete]="userAutocomplete"
    />
    <mat-autocomplete
      autoActiveFirstOption
      #userAutocomplete="matAutocomplete"
      (closed)="closeDialog()"
      (optionSelected)="selectionMade($event)"
    >
      <mat-option *ngFor="let option of optionsFiltered" [value]="option._id">
        <mat-icon matListItemIcon>{{
          option.selectedForAll
            ? 'done'
            : option.selectedForSome
            ? 'indeterminate_check_box'
            : ''
        }}</mat-icon>
        <div matListItemTitle>{{ option.title }}</div>
        <div matListItemLine *ngIf="option.selectedForAll">
          (select to remove user)
        </div>
      </mat-option>

      <mat-option *ngIf="optionsFiltered.length === 0" disabled="true">
        No user found.
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</form>
